export default "__VITE_ASSET__CSXjfSUz__"